import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Divider,
  Grid
} from '@mui/material';
import logo from '../../../assets/logo.jpg'
import CustomButton from '../../CustomButton';
const CreditNotePrintTemplate = ({ open, onClose, creditNoteDetails }) => {
  const {
    company = {},
    // supplier = '',
    // supplierAddress = '',
    creditNoteNumber = '',
    creditNoteDate = '',
    invoiceNumber = '',
    poNumber = '',
    currency = '',
    shipTo = '',
    purchaseOrderTo = '',
    // items = [],
    summary = {}, // expected: { creditNote: {}, additionalCosts: {}, total: {} }
    notes = ''
  } = creditNoteDetails;

  const printTableSection = (title, data = {}) => (
    <Box>
      <Typography fontWeight="bold" textAlign="center" bgcolor="#f0f0f0" p={1}>
        {title}
      </Typography>
      <Table size="small">
        <TableBody>
          {Object.entries(data).map(([key, value]) => (
            <TableRow key={key}>
              <TableCell>{key}</TableCell>
              <TableCell align="right">{value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );

  const handlePrint = () => {
    window.print();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

      <DialogTitle>Purchase Return</DialogTitle>
      <img src={logo} alt="logo" style={{ width: '100px', height: '100px' }} />
        </div>
      <DialogContent sx={{ p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          {/* Left Column: Company Info */}
          <Box width="40%">
            <Typography variant="h6">{company.name || 'Northern THC Group Ltd 2'}</Typography>
            <Typography>{company.address || '123 Main St, City, Country'}</Typography>
            <Typography>Phone: {company.phone || '(416) 988-7816'}</Typography>
            <Typography>Fax: {company.fax || '-'}</Typography>
            <Typography>Email: {company.email || 'info@northerntnc.com'}</Typography>
            <Typography>Web: {company.website || 'www.northerntnc.com'}</Typography>
          </Box>

          {/* Right Column: Credit Note Info */}
          <Box width="55%">
            <Typography><strong>Note Type:</strong> Purchase Return</Typography>
            <Typography><strong>Invoice No.:</strong> {invoiceNumber}</Typography>
            <Typography><strong>Credit Note No.:</strong> {creditNoteNumber}</Typography>
            <Typography><strong>Credit Note Date:</strong> {creditNoteDate}</Typography>
            <Typography><strong>PO No.:</strong> {poNumber}</Typography>
            <Typography><strong>Currency:</strong> {currency}</Typography>
          </Box>
        </Box>

        {/* Address Block */}
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Box width="48%">
            <Typography fontWeight="bold">Purchase Order To:</Typography>
            <Typography>{purchaseOrderTo || 'Canuck Cannabis'}</Typography>
          </Box>
          <Box width="48%">
            <Typography fontWeight="bold">Ship To:</Typography>
            <Typography>{shipTo || 'Northern THC Group Ltd'}</Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Grid Layout for Three Columns */}
        <Grid container >
          <Grid item xs={12} md={4}>
            {printTableSection("Credit Note", summary.creditNote)}
          </Grid>
          <Grid item xs={12} md={4}>
            {printTableSection("Additional Costs", summary.additionalCosts)}
          </Grid>
          <Grid item xs={12} md={4}>
            {printTableSection("Total", summary.total)}
          </Grid>
        </Grid>

        {/* Notes */}
        {notes && (
          <Box mt={3}>
            <Typography fontWeight="bold">NOTES:</Typography>
            <Typography>{notes}</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        {/* <Button onClick={onClose}>Close</Button>
        <Button onClick={handlePrint} variant="contained" color="primary">Print</Button> */}
        <CustomButton onClick={onClose} text={'Close'} variant="contained" bgcolor={"grey"} color={'black'} />
        <CustomButton onClick={handlePrint} text={'Print'} variant="contained"  bgcolor={"#95ABEB"} color={'black'}/>
      </DialogActions>
    </Dialog>
  );
};

export default CreditNotePrintTemplate;
